<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="首页banner" name="Banner_homepage">
        <bannerHomepage></bannerHomepage>
      </el-tab-pane>
      <el-tab-pane label="栏目" name="Banner_subject">
        <bannerSubject></bannerSubject>
      </el-tab-pane>
    </el-tabs>
    <router-view></router-view>
  </div>
</template>
<script>
  import bannerHomepage from './banner_homepage/banner_homepage';
  import bannerSubject from './banner_subject/banner_subject';
  export default {
    data() {
      return {
        activeName: 'Banner_homepage'
      };
    },
    components: {
      bannerHomepage, bannerSubject
    },
    created() {

    },
    mounted() {

    },
    methods: {
      handleClick(tab, event) {

      }
    },

  };
</script>



// WEBPACK FOOTER //
// src/pages/system/banner.vue